const sweetsData = [
    {
        title: "Brownie",
        image: require("../image/sweet/dessert-brownie.png"),
        paragraphe: "Chocolat",
        price: "sweetprice",
        top: "",
    },
    {
        title: "Glace",
        image: require("../image/sweet/dessert-hageendazs.png"),
        paragraphe:"Glace Häagen-Dazs parfum Vanille, Caramel et Brownie. Disponibilité selon arrivage.",
        price: "iceCreamPrice",
        top: "*",
    },
    {
        title: "Tarte aux pommes",
        image: require("../image/sweet/dessert-tartepomme.png"),
        paragraphe: "Pommes",
        price: "sweetprice",
        top: "*",
    },
    {
        title: "Tiramisu Nubi",
        image: require("../image/sweet/dessert-tiramisu.png"),
        paragraphe: "Différents parfums",
        price: "sweetprice",
        top: "*",
    },
];

export default sweetsData;
